export enum DateFormats {
	YYYY_MM_DD = 'YYYY-MM-DD',
	YYYY_MM_DD_HH_MM = 'YYYY-MM-DD HH:mm',
}
